import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { EmpresasBloqueadasRoutingModule } from './empresas-bloqueadas-routing.module';
import { EmpresasBloqueadasPesquisaComponent } from './empresas-bloqueadas-pesquisa.component';
import { EnvioConsultaProtocoloEmpresaComponent } from './envio-consulta-protocolo-empresa/envio-consulta-protocolo-empresa.component';
import { ProtocolConsultaEmpresaListagemComponent } from './envio-consulta-protocolo-empresa/envio-consulta-protocolo-empresa-listagem.component';
import { EmpresasBloqueadasLoteComponent } from './empresas-bloqueadas-lote.component';
import { EmpresasBloqueadasIndividualComponent } from './empresas-bloqueadas-individual.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
	  SharedModule,
    EmpresasBloqueadasRoutingModule,
    NgSelectModule
  ],
  declarations: [
    EmpresasBloqueadasPesquisaComponent,
    EnvioConsultaProtocoloEmpresaComponent,
    ProtocolConsultaEmpresaListagemComponent,
    EmpresasBloqueadasLoteComponent,
    EmpresasBloqueadasIndividualComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EmpresasBloqueadasModule { }
